import { isMaxLength, isMinLength, isRequired } from "@formiz/validations";

import { PERSONA_FIELD_LIMITS } from "@/constants";
import { isUsernameValid } from "@/utils";

import { ProfileFormFields } from "../types";

export const getProfileFormFieldSchema = (
  field: Exclude<ProfileFormFields, ProfileFormFields.AVATAR>,
  t: (key: string, options?: Record<string, unknown>) => string,
) => {
  return {
    [ProfileFormFields.USERNAME]: {
      validations: [
        {
          rule: (value: string) => isRequired()(value?.trim()),
          message: t("user:profile.validation.username.required"),
        },
        {
          rule: isMinLength(3),
          message: t("user:profile.validation.username.minLength"),
        },
        {
          rule: isMaxLength(20),
          message: t("user:profile.validation.username.maxLength", { maxLength: 20 }),
        },
        {
          rule: (value?: string) => isUsernameValid(value || ""),
          message: t("user:profile.validation.username.invalidCharacters"),
        },
      ],
      maxLength: 20,
    },
    [ProfileFormFields.NAME]: {
      validations: [
        {
          rule: (value: string) => isRequired()(value?.trim()),
          message: t("user:profile.validation.name.required"),
        },
        {
          rule: isMinLength(3),
          message: t("user:profile.validation.name.minLength"),
        },
        {
          rule: isMaxLength(20),
          message: t("user:profile.validation.name.maxLength", { maxLength: 20 }),
        },
      ],
      maxLength: 20,
    },
    [ProfileFormFields.HIGHLIGHTS]: {
      validations: [
        {
          rule: isMaxLength(PERSONA_FIELD_LIMITS.HIGHLIGHT),
          message: t("user:profile.validation.highlights.maxLength", { maxLength: PERSONA_FIELD_LIMITS.HIGHLIGHT }),
        },
        {
          rule: isMinLength(3),
          message: t("user:profile.validation.highlights.minLength"),
        },
      ],
      maxLength: PERSONA_FIELD_LIMITS.HIGHLIGHT,
    },
  }[field];
};
